import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/topics";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料热点</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              {siteInfo.intro}
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-200/90">
              <i className="ri-mail-line text-base"></i>
              {siteInfo.email}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              站点导航
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/" className="text-background-200/90 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="text-background-200/90 transition-colors hover:text-background-50">
                  热点复盘
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/90 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200/90 transition-colors hover:text-background-50">
                  内容原则
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              热门分类
            </h4>
            <ul className="mt-4 flex flex-wrap gap-2 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?cat=${cat.id}`}
                    className="inline-block rounded-md border border-primary-800 px-3 py-1.5 text-background-200/90 transition-colors hover:border-primary-500 hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料热点 · 内容仅作事件脉络整理与多方观点引用，不代表对任何一方的定论。</p>
          <p>理性看待热点，多源求证后再下判断。</p>
        </div>
      </div>
    </footer>
  );
}